export default __webpack_public_path__ + "static/media/shortLogoLeadsRubix.e00ac7a3.svg";